var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEckoWalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.028,
    y1: -0.028,
    x2: 0.859,
    y2: 0.859,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff00b8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113172",
    "data-name": "Group 113172",
    transform: "translate(9 18987)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24173",
    "data-name": "Rectangle 24173",
    width: 32,
    height: 32,
    rx: 16,
    transform: "translate(-9 -18987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143847",
    "data-name": "Path 143847",
    d: "M-1517.224,6457.551l-.762-.763-1.682-1.682,1.682-1.683.762-.762.763.762,1.682,1.683-1.682,1.682Zm0,2.358v5.028l-7.318-7.318,2.515-2.514Zm-7.318-7.316v5.026l2.515-2.514,4.8-4.8v-5.028Z",
    transform: "translate(1526.668 -25426.117)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEckoWalletLogo);
export default __webpack_public_path__ + "static/media/eckoWALLET_logo.7242edc34d967b0ac3f41f7d8a3f9203.svg";
export { ForwardRef as ReactComponent };